import axois from "axios";
import { BaseApiService } from "./api-base";

export class WfAuthApiService extends BaseApiService {
  get url() {
    // TODO: get_user вызывать после init
    return "api/wf";
    // return this.store.state.settings.list.services.value.wf.url;
  }
  get jwt() {
    return undefined;
    // return "Bearer " + this.store.state.settings.list.services.value.wf.jwt;
  }

  constructor(host: string) {
    super("wf");
    this.http = axois.create({
      baseURL: host,
    });
    this.http.interceptors.request.use((config) => {
      config.headers.Authorization = this.jwt;
      return config;
    });
  }

  get_user(ma_session: any) {
    const path = `${this.url}/get_user`;
    const body = { ma_session };
    return this.http.post(path, body).then((response) => response.data);
  }

  signin(login: string, password: string) {
    const path = `${this.url}/signin`;
    const body = { login, password };
    return this.http.post(path, body).then((response) => response.data);
  }

  signout(ma_session: string) {
    const path = `${this.url}/signout`;
    const body = { ma_session };
    return this.http.post(path, body).then((response) => response.data);
  }
}
